module.exports = __webpack_public_path__ + "media/images/paypal-logo-icon-e18b2836ae6b4766fc15dcb60af3834b.svg";